import { Input, Tooltip } from 'antd';
import { FormItem } from '../FormItem';
import styles from '../Input/Input.module.scss';
import cn from 'classnames';
import { InfoCircleTwoTone } from '@ant-design/icons';
import cln from 'classnames';

interface TextareaI {
  name: string;
  label?: string | JSX.Element;
  placeholder?: string;
  errorMessage?: string;
  defaultValue?: string;
  onChangeValue?: (e: any) => void;
  row?: number;
  example?: string;
  disabled?: boolean;
}

const { TextArea } = Input;

const Textarea = ({
  errorMessage,
  label = '',
  name,
  placeholder,
  defaultValue,
  onChangeValue,
  row = 4,
  example = '',
}: TextareaI) => {
  return (
    <div className={cn(styles.wrapper, { [styles.wrapper_withLabel]: label })}>
      <div>{label}:</div>
      <FormItem message={errorMessage} name={name}>
        <div className={cln({ [styles.textarea]: !!example })}>
          <TextArea
            rows={row}
            placeholder={placeholder}
            defaultValue={defaultValue}
            onChange={onChangeValue}
          />
          {!!example && (
            <div className={styles.example}>
              <TextArea rows={row} value={example} readOnly disabled={true} />
              <div className={styles.exampleIcon}>
                <Tooltip title="Cooking step for example. You can copy this text." color={'blue'}>
                  <InfoCircleTwoTone style={{ fontSize: 22 }} />
                </Tooltip>
              </div>
            </div>
          )}
        </div>
      </FormItem>
    </div>
  );
};

export default Textarea;
